<div class="fieldset">
  <span class="fieldset-label">{{contentData.addressSearch}}</span>
  <div class="form-group fieldset-label-container">

    <div class="form-field">
      <input type="checkbox" id="checkbox-group-5-{{index}}" name="checkbox-group-c-{{index}}" class="form-control"
        aria-invalid="false" value="checkbox-group-5-{{index}}-value" aria-labelledby="checkbox-error"
        [checked]="mainParent.get('addressSearchChecked').value" (change)="onToggleUKDoctorAddress($event,mainParent)"
        formControlName="addressSearchChecked" />
      <label for="checkbox-group-5-{{index}}"></label>
      <span class="padding-checkbox-title-{{index}}">{{contentData.sameAsMine}}</span>
    </div>
  </div>
</div>

<div class="col-md-12 clear-all clear-padding" *ngIf="showIsUKFlag">
  <div role="button" aria-describedby="ukIndicatorText" class="alignUKIndicator">
    <!-- <span class="form-label" id="ukIndicatorText" for="ukAddressIndicator" style="margin-top: 32px">{{contentData.personalDetail.ukAddressIndicator}}</span> -->
    <div class="mt-10">
      <app-question [questiontextRequired]="true" [childId]="'ukAddressIndicator'"
        [questionConfig]="userInputDetail.radioButtonIsBeneficiaryUKAddressConfig" [parent]="mainParent"
        [controlName]="'ukAddressIndicator'" (toggleChange)="toggleContainer($event)" [id]="'ukAddressIndicator'">
      </app-question>

    </div>
  </div>
  <form [formGroup]="address">
    <div class="col-md-12 wrapperMargin pad clear-padding">
      <div *ngIf="showSearchAddress" class="margin-top-30">
        <div class="col-md-12 clear-all ">
          <div class="col-md-5 clear-all">
            <app-addressLines [pageName]="'beneficiaryDetails'" [parent]="address"
              [controllerData]="addressLine1CodeConfig" [controlName]="'addressline1'">
            </app-addressLines>
          </div>
        </div>
        <div class="col-md-12 clear-all margin-top-30">
          <div class="col-md-5 clear-all">
            <app-addressLines [pageName]="'beneficiaryDetails'" [parent]="address"
              [controllerData]="addressLine2CodeConfig" [controlName]="'addressline2'">
            </app-addressLines>
          </div>
        </div>
        <div class="col-md-12 clear-all margin-top-30">
          <div class="col-md-5 clear-all">
            <app-addressLines [pageName]="'beneficiaryDetails'" [parent]="address"
              [controllerData]="addressLine3CodeConfig" [controlName]="'addressline3'">
            </app-addressLines>
          </div>
        </div>
        <div class="col-md-12 clear-all margin-top-30">
          <div class="col-md-5 clear-all">
            <app-addressLines [pageName]="'beneficiaryDetails'" [parent]="address"
              [controllerData]="addressLine4CodeConfig" [controlName]="'addressline4'">
            </app-addressLines>
          </div>
        </div>

        <div class="col-md-12 clear-all margin-top-30" *ngIf="!overseasCustomer">
          <div class="col-md-5 clear-all">
            <app-postcode [postCodeConfig]="postCodeConfig" [pageName]="'beneficiaryDetails'" [controlName]="'postcode'" formControlName="postcode"
              [parent]="address" [required]="'true'">
            </app-postcode>
          </div>

        </div>
        <!-- Country dropdown for overseas starts here -->
        <div class="col-md-12 clear-all margin-top-30 form-field" *ngIf="overseasCustomer">
          <!-- <app-country [parent]="address" [countryConfig]="countryConfig" [controlName]="'country'" [formControlName]="countryCode" [countriesList]="countriesList"></app-country> -->
          <div class="form-field col-md-5 clear-all" [ngClass]="{'has-error': address.get('countryCode').touched
&& address.get('countryCode').errors}">
            <div class="dropdown-control">
              <label id="othTitle"> {{countryConfig.label}} </label>

            </div>
            <div class="form-field-select">

              <select id="country" formControlName="countryCode" class="form-control some" aria-invalid="false"
                [ngModel]="countryName ? countryName : null" (change)="getCountryCode($event.target.value)">
                <option [disabled]="false" [ngValue]="null">Please select</option>
                <option *ngFor="let country of countriesList" [value]="country.key">
                  {{country['description']}}</option>
              </select>
              <i class="icon icon-chevron-down" aria-hidden="true"></i>
            </div>

            <div class="form-validation-error" *ngIf="address.get('countryCode').touched
                      && address.get('countryCode').errors 
                      && address.get('countryCode').hasError('required')">
              <i class="icon icon-error" aria-hidden="true"></i>
              <p>{{countryConfig.errorMessage}}</p>
            </div>
          </div>
        </div>

        <!-- Country dropdown for overseas doctor's ends here -->
        <div class="mt-10 float-left" *ngIf="!overseasCustomer">
          <p class="font-weight-300 font-size subtitle clear-all" id="address-manual-p">
            <strong>
              <a id="address-manual" (click)="onAddressSeachClick()" class="clickHere mr-7">
                search for another address </a>
            </strong>
          </p>
        </div>
      </div>
      <div *ngIf="addressSearchEnabled" class="margin-top-30">
        <div class="col-md-12 clear-all">
          <div class="col-md-5 clear-all">
            <app-address-search [parent]="address" [pageName]="'beneficiaryDetails'"
              (onSelecteAddress)=onSelecteAddress($event)></app-address-search>
          </div>
        </div>
        <div>
          <p class="font-weight-300 font-size subtitle clear-all" id="address-qas-p">
            <strong>
              <a id="address-qas" (click)="onManualClick()" class="clickHere mr-7">
                enter address manually</a>
            </strong>
          </p>
        </div>
      </div>
    </div>
  </form>